import Vue from 'vue'
import * as jsonpatch from 'fast-json-patch/index.mjs'

const luExciseIssues = {
  state: {
    luExciseIssues: [],
    selectedLuExciseIssues: {},
    selectedLuExciseIssuesOriginal: {},
    saving: false,
    searchCount: 0,
  },

  getters: {
    luExciseIssues(state) {
      return state.luExciseIssues
    },
    selectedLuExciseIssues(state) {
      return state.selectedLuExciseIssues
    },
    selectedLuExciseIssuesOriginal(state) {
      return state.selectedLuExciseIssuesOriginal
    },
    loading(state) {
      return state.searchCount > 0
    },
  },

  mutations: {
    luExciseIssues(state, payload) {
      state.luExciseIssues = payload
    },
    selectedLuExciseIssues(state, payload) {
      state.selectedLuExciseIssues = JSON.parse(JSON.stringify(payload))
    },
    selectedLuExciseIssuesOriginal(state, payload) {
      state.selectedLuExciseIssuesOriginal = JSON.parse(JSON.stringify(payload))
    },
    saving(state, payload) {
      state.saving = payload
    },
    searchCount(state, payload) {
      state.searchCount = payload
    },
    increaseSearchCount(state, payload) {
      state.searchCount = state.searchCount + 1
    },
    decreaseSearchCount(state, payload) {
      state.searchCount = state.searchCount - 1
    },
  },

  actions: {
    setSelectedLuExciseIssues(context, payload) {
      context.commit('selectedLuExciseIssues', payload)
    },
    loadLuExciseIssues(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'LuExciseIssues'
        Vue.prototype.$axios
        .get(url)
        .then(
          (res) => {
            context.commit('luExciseIssues', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          },
        )
      })
    },
    refreshSelectedLuExciseIssues(context, payload) {
      if (context.state.selectedLuExciseIssues && context.state.selectedLuExciseIssues.ID > 0) {
        context.dispatch('loadSelectedLuExciseIssues', context.state.selectedLuExciseIssues.ID)

      }
    },
    loadSelectedLuExciseIssues(context, payload) {
      if (context.state.selectedLuExciseIssues && context.state.selectedLuExciseIssues.ID != payload) {
        context.commit('selectedLuExciseIssues', {})
      }
      return new Promise((resolve, reject) => {
        const url = 'LuExciseIssues/' + payload
        context.commit('increaseSearchCount')
        Vue.prototype.$axios
        .get(url)
        .then(
          (res) => {
            context.commit('selectedLuExciseIssues', res.data)
            context.commit('selectedLuExciseIssuesOriginal', res.data)
            context.commit('decreaseSearchCount')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('decreaseSearchCount')
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          },
        )
      })
    },
    clearLookupCacheAndReloadLuExciseIssues(context, payload) {
      caches.delete('apilookup-cache').finally(() => {
          context.dispatch('loadLuExciseIssues')
      }, )
    },
    createLuExciseIssues(context, payload){
      return new Promise((resolve, reject) => {
        const url = `LuExciseIssues`
        context.commit('saving', true)
        Vue.prototype.$axios
        .post(url, payload)
        .then(
          (res) => {
            context.dispatch('messages/toastMessage',
            {color: 'success', message: 'excise issues created',},{ root: true })
            //if you will always need to reload the list after an item is created
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuExciseIssues')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          },
        )
      })
    },
    patchLuExciseIssues(context, payload){
      return new Promise((resolve, reject) => { 
        var item = context.state.selectedLuExciseIssues
        if (payload.ID && 
        payload.ID == context.state.selectedLuExciseIssuesOriginal.ID)  {
        item = payload
        }
        var patchPayload = {}
        if (!payload.patchDoc || !payload.ID) {
          let original = context.state.selectedLuExciseIssuesOriginal
          let current = item
          patchPayload.ID = item.ID
          var diff = jsonpatch.compare(
                original,
                current
              )
          patchPayload.patchDoc = diff

        } else {
          patchPayload = payload
        }
        if (patchPayload.patchDoc.length > 0) {
          const url = `LuExciseIssues/${ patchPayload.ID }`
          context.commit('saving', true)
          Vue.prototype.$axios
          .patch(url, patchPayload.patchDoc)
          .then(
            (res) => {
              context.dispatch('messages/toastMessage',
              {color: 'success', message: 'excise issues updated',},{ root: true })
              //if you will always need to reload the list after an update
              //you can uncomment out the following dispatch line.
              //Alternatively you can reload whatever object you need
              //when the promise resolves in the component that called it.
              //context.dispatch('loadLuExciseIssues')
              context.commit('saving', false)
              resolve(res)
            },
            (err) => {
              console.error(err)
              context.commit('saving', false)
              context.dispatch('errors/handleError', err, { root: true })
              reject(err)
            },
          )
        } else {
          resolve('no changes')
        }
      })
    },
    updateLuExciseIssues(context, payload){
      return new Promise((resolve, reject) => { 
        const url = `LuExciseIssues/${ payload.ID }`
        context.commit('saving', true)
        Vue.prototype.$axios
        .put(url, payload)
        .then(
          (res) => {
            context.dispatch('messages/toastMessage',
            {color: 'success', message: 'excise issues updated',},{ root: true })
            //if you will always need to reload the list after an update
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuExciseIssues')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          },
        )
      })
    },
    saveLuExciseIssues(context, payload){
      return new Promise((resolve, reject) => {
        if (payload.ID > 0) {
          context.dispatch('updateLuExciseIssues', payload)
          .then((res) => resolve(res), (err) => reject(err))
        } else {
          context.dispatch('createLuExciseIssues', payload)
          .then((res) => resolve(res), (err) => reject(err))
        }
      })
    },
    deleteLuExciseIssues(context, payload){
      return new Promise((resolve, reject) => {
        const url = `LuExciseIssues/${ payload.ID }`
        Vue.prototype.$axios
        .delete(url)
        .then(
          (res) => {
            context.dispatch('messages/toastMessage',
            {color: 'success', message: 'excise issues deleted',},{ root: true })
            //if you will always need to reload the list after a delete
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuExciseIssues')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          },
        )
      })
    },
  },
}

export default luExciseIssues